// src/hooks/useScrollAnimation.js
import { useEffect } from 'react';

const useScrollAnimation = (selector = '.fade-in, .slide-up, .slide-right, .slide-left, .fade-in-delay, .fade-in-delay-1, .fade-in-delay-2, .fade-in-delay-3, .slide-up-delay-1, .slide-up-delay-2, .slide-up-delay-3, .slide-up-delay-4') => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        } else {
          entry.target.classList.remove('show');
        }
      });
    }, { threshold: 0.1 });

    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, [selector]);
};

export default useScrollAnimation;
